import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { Login } from './components/Login'
import { ProtectedRoute } from './components/ProtectedRoute'
import { SoundMixer } from './components/SoundMixer'
import { Layout } from './components/Layout'
import { AdminUpload } from './components/AdminUpload'
import { useAuth } from './contexts/AuthContext'

function AppContent() {
  const { user, login } = useAuth()
  const navigate = useNavigate()

  return (
    <Routes>
      <Route path="/login" element={
        <Login onLogin={async (email, password) => {
          try {
            await login(email, password)
            navigate('/')
          } catch (error) {
            throw error
          }
        }} />
      } />
      
      <Route path="/" element={
        <ProtectedRoute>
          <Layout>
            <SoundMixer brandId={user?.brandId || ''} />
          </Layout>
        </ProtectedRoute>
      } />

      <Route path="/admin/upload" element={
        <ProtectedRoute>
          <Layout>
            <AdminUpload />
          </Layout>
        </ProtectedRoute>
      } />
    </Routes>
  )
}

export function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  )
}
